import { jsx as _jsx } from "react/jsx-runtime";
import { Box, SelectAlpha } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { mapAndesSizeSelectOptions } from '../../util/ProductUtil';
export const ProductTileSizeSelect = ({ colorId, productId, selectedSku, sizes, isOneSizeProduct, onSizeChange, hasError, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const items = mapAndesSizeSelectOptions(sizes, true);
    const handleSelect = (item) => {
        onSizeChange(String(item.id));
    };
    return (_jsx(Box, { flex: { grow: 1 }, children: _jsx(SelectAlpha, { input: {
                id: `product_tile_size_select_${productId}_${colorId}`,
                placeholder: t(isOneSizeProduct ? 'product.extensiveBlock.singleSizeAvailable' : 'pdp.size.choose.default'),
                error: hasError,
                required: true,
            }, name: `size-select-${productId}-${colorId}`, testId: "size-select", items: items, value: selectedSku || undefined, onSelect: handleSelect }) }));
};
